import keyMirror from 'keymirror';

export const liveBattleActionTypes = keyMirror({
	CREATE_LIVE_BATTLE: null,
	CREATE_LIVE_BATTLE_SUCCESS: null,
	CREATE_LIVE_BATTLE_ERROR: null,
	GET_BATTLE_ROOM_DATA: null,
	GET_BATTLE_ROOM_DATA_SUCCESS: null,
	GET_BATTLE_ROOM_DATA_ERROR: null,
	CHECK_OUT_BATTLE: null,
	CHECK_OUT_BATTLE_SUCCESS: null,
	CHECK_OUT_BATTLE_ERROR: null,
	CLOSE_BATTLE: null,
	CLOSE_BATTLE_SUCCESS: null,
	CLOSE_BATTLE_ERROR: null,
	CHANGE_BATTLE_SETTINGS: null,
	CHANGE_BATTLE_SETTINGS_SUCCESS: null,
	CHANGE_BATTLE_SETTINGS_ERROR: null,
	START_BATTLE: null,
	START_BATTLE_SUCCESS: null,
	START_BATTLE_ERROR: null,
	TOGGLE_CLOSE_ROOM_MODAL: null,
	TOGGLE_ROOM_SETTINGS_MODAL: null,
	TOGGLE_CONTINUE_PRACTICING_MODAL: null,
	GO_TO_NEXT_BATTLE_SCREEN: null,
	GO_TO_NEXT_BATTLE_SCREEN_SUCCESS: null,
	GO_TO_NEXT_BATTLE_SCREEN_ERROR: null,
	GET_ANSWER_RESULTS: null,
	GET_ANSWER_RESULTS_SUCCESS: null,
	GET_ANSWER_RESULTS_ERROR: null,
	GET_QUESTION_ANSWERS: null,
	GET_QUESTION_ANSWERS_SUCCESS: null,
	GET_QUESTION_ANSWERS_ERROR: null,
	SKIP_BATTLE_QUESTION: null,
	SET_LIVE_BATTLE_ANSWER_SUMMARY: null,
	CLEAR_LIVE_BATTLE_STATE: null,
	CLEAR_REMAINING_TIME: null,
	CLEAR_ANSWER_SUMMARY: null,
});

export const LIVE_CODE_LENGTH = 6;

export const getQuestionDetailsById = (isQuizExercise, id, questions) => {
	let question = {};
	let currentQuestionPosition = 1;
	questions &&
		questions.forEach((item, index) => {
			if (item[isQuizExercise ? 'id' : 'word_id'] === id) {
				question = item;
				currentQuestionPosition = index + 1;
			}
		});
	return { question, currentQuestionPosition };
};
